<template>
  <form @submit.prevent="onSearch" class="mt-3 mb-3">
    <div class="row ">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.unemployedLastName"
            :options="unemployedDropdown"
            :is-clear="true"
            :showMinCharsMessage="true"
            :placeholder="$t('placeholder.last_name')"
            :no-options-text="'Type to search...'"
            @dropdown-fetch="(search) => handleDropdownSearch(search, 'lastName')"
            @update:modelValue="(val) => onSelectValue(val, 'lastName')"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="coachDropdown && coachDropdown.length">
          <SelectVue
              v-model="filters.coachId"
              :options="coachDropdown"
              :is-clear="true"
              :placeholder="$t('general.coach')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              :placeholder="$t('general.office')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-12 col-12 order-last order-lg-0 text-center text-lg-left mb-3 mb-lg-0">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="operationTypeDropdown && operationTypeDropdown.length">
          <SelectVue
              v-model="filters.operationType"
              :options="operationTypeDropdown"
              :is-clear="true"
              :placeholder="$t('general.operation_type')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"
            :placeholder="$t('general.start_date')"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            :placeholder="$t('general.end_date')"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Reactive filters
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  unemployedDropdown: {
    type: Array,
    required: true,
  },
  coachDropdown: {
    type: Array,
    required: true,
  },
  operationTypeDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);
const unemployedDropdown = toRefs(props)['unemployedDropdown'];
const coachDropdown = toRefs(props)['coachDropdown'];
const operationTypeDropdown = toRefs(props)['operationTypeDropdown'];
const officeDropdown = toRefs(props)['officeDropdown'];
const emit = defineEmits(['search']);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function handleDropdownSearch(search) {
  emit('dropdown-fetch', search);
}

function onSelectValue(value){
  if (!value) {
    emit('clear-dropdown');
  }
}
</script>

<style scoped>
/* Add any custom styles for your search component */
</style>
